module.exports = __webpack_public_path__ + "img/Sunu-Widyatmoko@2x.fa42d5b4.png";